import {
    getCateringEventFormatBySlug,
    GetCateringEventFormatBySlugApiResponseSchema,
} from './get-catering-event-format-by-uid';
import {
    getCateringEventsByFormatSlug,
    GetCateringEventsByFormatSlugApiResponseSchema,
} from './get-catering-events-by-format-uid';

export {
    GetCateringEventFormatBySlugApiResponseSchema,
    GetCateringEventsByFormatSlugApiResponseSchema,
};

export const CateringEventFormatPageActions = {
    getCateringEventFormatBySlug,
    getCateringEventsByFormatSlug,
};
